import React from 'react';
import SvgIcon from '../../utils/SvgIcon';
import { Button, Link } from 'react-aria-components';

type ToastBulkDownloadsProps = {
  setShowPreparingFiles?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDownloadReady?: React.Dispatch<React.SetStateAction<boolean>>;
  downloadUrl?: string | null;
  type: 'preparing' | 'ready';
  svgIconName: string;
  heading: string;
  text: string;
  ctaText?: string;
};

export default function ToastBulkDownloads({
  setShowPreparingFiles,
  setShowDownloadReady,
  downloadUrl,
  type,
  svgIconName,
  heading,
  text,
  ctaText,
}: Readonly<ToastBulkDownloadsProps>) {
  function handleClose() {
    if (type === 'preparing' && setShowPreparingFiles) {
      setShowPreparingFiles(false);
    } else if (type === 'ready' && setShowDownloadReady) {
      setShowDownloadReady(false);
    }
  }

  return (
    <div className="bulk-download__toast-container">
      <div className={`bulk-download__toast bulk-download--${type}`}>
        <div className="bulk-download__toast-inner">
          <SvgIcon iconName={svgIconName} additionalClasses="bulk-download__toast-icon" aria-hidden="true" />
          <div className="bulk-download__toast-content">
            <h3 className="bulk-download__toast-heading">{heading}</h3>
            <p className="bulk-download__toast-text">{text}</p>
          </div>
        </div>
        <Button className="bulk-download__toast-close-btn" aria-label="Close toast" onPress={handleClose}>
          <SvgIcon iconName="x-mark-medium" additionalClasses="bulk-download__toast-close-icon" aria-hidden="true" />
        </Button>
        {type === 'ready' && (
          <div className="bulk-download__toast-actions">
            <Link
              href={downloadUrl || '#'}
              className="bulk-download__toast-cta cta cta--primary cta--small"
              target="_blank"
              rel="noopener noreferrer"
              onPress={handleClose}
              autoFocus={type === 'ready'}
            >
              <span>{ctaText}</span>
              <SvgIcon
                iconName="download-medium"
                additionalClasses="bulk-download__toast-cta-icon"
                aria-hidden="true"
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
